import { KEY_CODE } from "@shared/constants"

import store from "./store"

function eventListener() {
  ;(window as any).subscribeHotkeysLocalStorage = (hotkeys: number[]) => {
    Object.keys(KEY_CODE.Function).map((fKey, index) => {
      return store.local.set(`macro.${fKey}`, hotkeys[index] || "")
    })
  }
}

export { eventListener }
